import type { schemaType as DestinosSchemaType } from '~~/shared/api/strapi/destinos/detail/schema'
import type { SCardsWideProps } from '~~/modules/design-system/sections/s-cards-wide/index.vue'

export function useToSCardsWide() {
  function fromStrapiDestinationBanners(
    data: DestinosSchemaType,
  ): SCardsWideProps[] {
    return (
      data.attributes.destination_banners?.map(item => ({
        item: {
          image: item.image?.data?.attributes?.url || '',
          title: item.title || '',
          description: item.text || '',
          button: {
            text: item.button?.text || '',
            url: item.button?.url || '',
          },
        },
      })) || []
    )
  }
  return { fromStrapiDestinationBanners }
}
